interface FunnelStage {
  milestone: string;
  label: string;
  contacts: number;
}

/**
 * Embudo del negocio.
 *
 * Cada barra cuenta a quienes llegaron AL MENOS hasta esa etapa, así que el
 * ancho decrece y la caída entre etapas se lee de un vistazo — que es la única
 * pregunta interesante: dónde se pierde la gente.
 *
 * El porcentaje se calcula contra la PRIMERA etapa, no contra la anterior:
 * "de los que escribieron, cuántos agendaron" es la métrica que le importa al
 * negocio.
 */
export function FunnelChart({ stages }: { stages: FunnelStage[] }) {
  const top = stages[0]?.contacts ?? 0;

  if (top === 0) {
    return (
      <p className="text-body-sm text-content-tertiary dark:text-content-tertiary py-8 text-center">
        Todavía no hay contactos con etapa registrada en este período.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {stages.map((stage, i) => {
        const pct = Math.round((stage.contacts / top) * 100);
        const previous = stages[i - 1]?.contacts;
        const dropped = previous !== undefined ? previous - stage.contacts : null;

        return (
          <div key={stage.milestone}>
            <div className="flex items-baseline justify-between mb-1">
              <span className="text-body-sm font-medium text-neutral-800 dark:text-neutral-200">
                {stage.label}
              </span>
              <span className="text-body-sm tabular-nums text-neutral-600 dark:text-neutral-300">
                <span className="font-semibold">{stage.contacts}</span>
                <span className="text-content-tertiary ml-2">{pct}%</span>
              </span>
            </div>
            <div className="h-7 w-full rounded bg-neutral-100 dark:bg-neutral-800 overflow-hidden">
              <div
                className="h-full rounded bg-primary-500 dark:bg-primary-600 transition-[width] duration-500 motion-reduce:transition-none"
                style={{ width: `${pct}%` }}
              />
            </div>
            {dropped !== null && dropped > 0 && (
              <p className="text-xs text-content-tertiary dark:text-content-tertiary mt-1">
                {dropped} {dropped === 1 ? 'persona no avanzó' : 'personas no avanzaron'} desde “
                {stages[i - 1]?.label}”
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
